import { render } from "./CharlaAside.vue?vue&type=template&id=91b15aaa&scoped=true"
import script from "./CharlaAside.vue?vue&type=script&lang=js"
export * from "./CharlaAside.vue?vue&type=script&lang=js"

import "./CharlaAside.vue?vue&type=style&index=0&id=91b15aaa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b15aaa"]])

export default __exports__